import {create} from 'zustand';

import {AccountWithLogo} from '../../../shared/scoredAccounts';

export type AccountScorePreviewSelectedAccount = {
  selectedAccount: AccountWithLogo | undefined;
  setSelectedAccount: (s: AccountWithLogo | undefined) => void;
};

export const useAccountScorePreviewSelectedAccount =
  create<AccountScorePreviewSelectedAccount>((set) => ({
    selectedAccount: undefined,
    setSelectedAccount: (val) => set({selectedAccount: val}),
  }));
